import { NormalSideInput, MainAdminNewsesTopDropDown } from "../..";
import Upload from "../../../assets/icon/NewsIcons/MainAdmin/NewsUploadFile"
// import ArticleImageUpload from "../MainComponents/FileUpload"
import ArticleImageUpload from "../MainComponents/ArticleImageUpload"
import Delete from "../../../assets/icon/NewsIcons/MainAdmin/NewsDeleteWhite"
import React, { useEffect, useState } from "react";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { axiosReq } from "../../../commons/axiosReq";
import { apiAsset } from "../../../commons/inFormTypes";
import { useNavigate } from "react-router-dom";
import { DatePicker } from "zaman";
import { TimePicker } from "zaman";
import moment from 'jalali-moment'
import Cookies from 'universal-cookie';
import { Link } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";

const UploadNewsSideInput = ({ cats, text, tags, setRecheck, reCheck, data, edit, accept, video ,image}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  // const [publicatiponDate, setPublicatiponDate] = useState();
  // const [publicatiponTime, setPublicatiponTime] = useState();
  const [tag, setTag] = useState([]);
  const [errTag, setErorTag] = useState(false);
  const [errCat, setErorCat] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [title, setTitle] = useState();
  const [open, setOpen] = useState();
  const [photo, setPhoto] = useState();
  const [errPhoto, setErrPhoto] = useState();
  const [role, setRole] = useState();
  const [sniper, setSnipper] = useState(false);
  const [token, setToken] = useState();
  const [showErrorModalStep1,
    setShowErrorModalStep1] = useState(false);
  const [error, setError] = useState();
  let navigate = useNavigate();

  const [allValues, setAllValues] = useState({
    ArticleTitle: data ? data?.articleTittle : "",
    Slug: data ? data?.slug : "",
    SecondTitle: data ? data?.secondTitle : "",
    // NewsText: "",
    // MainPicture: "",
    MainPage: data ? data?.mainPage : false,
    NewsBox: data ? data?.newsBox : "",
    IsLast: data ? data?.isLast : false,
    IsProminent: data ? data?.isProminent : false,
    IsMostViewd: data ? data?.isMostViewed : false,
    // DatePublished:data?data?.datePublished:moment(new Date()).locale('fa').format('YYYY/MM/DD'),
    DatePublished: data ? data?.datePublished : null,
    //  data ?  moment(data?.datePublished?.split("T")[0].replace("-", "/"), 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD') : "",

    TimePublished: data ? data?.datePublished : null,
  });
  const [allValuesError, setAllValuesError] = useState({
    ArticleTitle: false,
    Slug: false,
    // NewsText: false,
    // MainPage: false,
    NewsBox: false,
    // IsLast: false,
    // IsProminent: false,
    // IsMostViewd: false,
    // DatePublished: false,
    // TimePublished: false,
    // AuthorId: false,
    // AdminId: false,
  });
  const changeHandler = e => {
    if (e.target) {
      if (e.target.value != "") {

        setAllValuesError({ ...allValuesError, [e.target.name]: false })
      }
      else {
        setAllValuesError({ ...allValuesError, [e.target.name]: true })

      }

      // console.log(e.target.value)
      setAllValues({ ...allValues, [e.target.name]: e.target.value })
    }
  }

  const handleSelectChange = (selected) => {
    setSelectedOptions(selected || []);
  };
  const handleTagChange = (newValue) => {
    setTag(newValue);
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#f1f5ff" : "#f1f5ff",
      borderRadius: 5, // رنگ بوردر در حالت فوکوس و غیرفوکوس
      "&:hover": {
        borderColor: "#f1f5ff", // رنگ بوردر هنگام هاور
      },
      boxShadow: state.isFocused ? "none" : "none", // سایه در حالت فوکوس
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#e8eeff", // رنگ پس‌زمینه تگ‌های انتخاب شده
      color: "#fff",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#000", // رنگ متن تگ‌های انتخاب شده
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#000",
      "&:hover": {
        backgroundColor: "#E64A19", // رنگ پس‌زمینه دکمه حذف هنگام هاور
        color: "white",
      },
    }),
  };
  const fixNumbers = function (str) {
    var
      persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
      arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]
    if (typeof str === 'string') {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  };
  const formatDateTime = (sDate) => {
    console.log(sDate)
    var lDate = new Date(sDate).toLocaleDateString('fa-IR');
    console.log(555)
    console.log(lDate)
    var d = fixNumbers(lDate.split('/')[2]);
    var dd = d < 10 ? '0' + d : d;
    var yyyy = fixNumbers(lDate.split('/')[0]);
    var mon = fixNumbers(lDate.split('/')[1]);
    var mm = (mon < 10 ? '0' + mon : mon);


    return yyyy + '/' + mm + '/' + dd;


  }

  const handleDeleteImage = () => {
    setPreviewImage(null); // حذف عکس پیش‌نمایش
  };


  const blurHandler = e => {
    if (e.target) {
      if (e.target.value == "") {

        setAllValuesError({ ...allValuesError, [e.target.name]: true })
      }

    }
  }
  const allFull = (obj) => {
    const updatedState = {};
    var result = true;

    for (var o in obj) {
      if (obj[o] === "" && o != "TimePublished" && o != "DatePublished" && o != "SecondTitle") {
        updatedState[o] = true;
        console.log(8888)
        console.log(o)
        console.log(obj[o])

        setAllValuesError({ ...allValuesError, ...updatedState })
        result = false;
      }


    }

    if (selectedOptions.length == 0) {
      setErorCat(true)

      result = false;

    }
    if (tag.length == 0) {
      setErorTag(true)
      result = false;

    }
    if (!photo && !data?.mainPicture) {
      setErrPhoto(true)
      result = false;

    }
    return result
  }

  const createArticle = async () => {

    setSnipper(true)
    var res = allFull(allValues)
    console.log(999)
    console.log(allValues.TimePublished)
    console.log(text)
    console.log(res)
    console.log(selectedOptions)

    if (res) {
      // if (selectedOptions.length > 0) {
      var catSel = "";
      var tagSel = "";
      selectedOptions?.map((item) => {
        catSel += item?.value + ","
      })
      tag?.map((item) => {
        tagSel += item?.value + ","
      })
      const catval = catSel.substring(0, catSel.length - 1);
      const tagval = tagSel.substring(0, tagSel.length - 1);
      var newsText = text;

      if (video?.length > 0) {
        const toSearch="<p>video</p>"

        const target = text.indexOf(toSearch);
        console.log(11)
        const firstPart = text.substring(0,target);
        console.log(22)

        const secondPart = text.substring(target + toSearch.length, text.length)
        console.log(33)

        // newsText = firstPart + '<video controls width=320 height=240 ><source src="https://api.bordarna.ir/uploads/output_reduced_size_20250204110821_2c09.mp4" type="video/mp4"></video>' + secondPart;
        newsText = firstPart + video + secondPart;
      }
       if (image?.length > 0) {
        const toSearch = /<p>image<\/p>/g;
        
        // If image is an array, use them in order
        if (Array.isArray(image)) {
            let counter = 0;
            newsText = text.replace(toSearch, () => {
                return counter < image.length ? image[counter++] : "<p>image</p>";
            });
        } 
        // If image is a single string, replace all with the same
        else {
            newsText = text.replace(toSearch, image);
        }
    }
      if (!newsText || newsText.replace(/<[^>]*>/g, "").trim().length === 0) {
        setSnipper(false); setShowErrorModalStep1(true); setError("متن مقاله را وارد نمایید"); return;
      }
      const dataUser = await axiosReq("Article/CreateArticle", "post", {
        ArticleTittle: allValues.ArticleTitle,
        Slug: allValues.Slug,
        NewsText: newsText,
        SecondTitle: allValues.SecondTitle,
        // MainPicture: photo,
        MainPicture: photo,
        MainPage: allValues.MainPage,
        Categories: catval,
        Tags: tagval,
        // Tags: "1",
        NewsBox: allValues.NewsBox,
        IsLast: allValues.IsLast,
        IsProminent: allValues.IsProminent,
        IsMostViewed: allValues.IsMostViewd,
        DatePublished: role == "Admin" ?
          allValues.DatePublished + "T" + allValues.TimePublished : null
        //  moment(new Date()).locale('fa').format('YYYY/MM/DD')+"T"+moment(new Date()).locale('fa').format('hh:mm') 

        // DateModified:"2021-09-01T00:00:00",
      });
      console.log(dataUser)
      if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
        setSnipper(false)

        alert("موفقیت آمیز");
        navigate("/mainAdmin/PublishedNewses");
      }
      else {
        setSnipper(false)

        console.log(allValuesError)
        console.log(dataUser)
        setShowErrorModalStep1(true)
        setError(dataUser?.data ? dataUser?.data : "عملیات ناموفق بود");

      }

    }
    else {
      setSnipper(false)

      console.log(222)
      console.log(allValuesError)
      setShowErrorModalStep1(true);
      setError("لطفا موارد ستاره دار را وارد نمایید")
      // alert("عملیات ناموفق بود");


    }
  }

  const updateArticle = async () => {

    setSnipper(true)
    var res = allFull(allValues)
    console.log(999)
    console.log(photo)
    console.log(text)
    console.log(res)
    console.log(selectedOptions)

    if (res) {
      // if (selectedOptions.length > 0 && tag.length > 0) {
      // if (selectedOptions.length > 0) {
      var catSel = "";
      var tagSel = "";
      selectedOptions?.map((item) => {
        catSel += item?.value + ","
      })
      tag?.map((item) => {
        tagSel += item?.value + ","
      })
      var newsText = text;
      console.log("video",video)
      if (video?.length > 0) {
        const toSearch="<p>video</p>"

        const target = text.indexOf(toSearch);
        console.log(11)
        const firstPart = text.substring(0,target);
        console.log(22)

        const secondPart = text.substring(target + toSearch.length, text.length)
        console.log(33)

        newsText = firstPart + video + secondPart;
      }

      if (image?.length > 0) {
        const toSearch = /<p>image<\/p>/g;
        
        // If image is an array, use them in order
        if (Array.isArray(image)) {
            let counter = 0;
            newsText = text.replace(toSearch, () => {
                return counter < image.length ? image[counter++] : "<p>image</p>";
            });
        } 
        // If image is a single string, replace all with the same
        else {
            newsText = text.replace(toSearch, image);
        }
    }
      const catval = catSel.substring(0, catSel.length - 1);
      const tagval = tagSel.substring(0, tagSel.length - 1);
      if (!newsText || newsText.replace(/<[^>]*>/g, "").trim().length === 0) {
        setSnipper(false); setShowErrorModalStep1(true); setError("متن مقاله را وارد نمایید"); return;
      }
      const dataUser = await axiosReq("Article/UpdateArticle", "post", {
        ArticleId: data?.articleId,
        ArticleTittle: allValues.ArticleTitle,
        Slug: allValues.Slug,
        NewsText: newsText,
        SecondTitle: allValues.SecondTitle,
        // MainPicture: photo,
        MainPicture: photo ? photo : data ? data?.mainPicture : "",
        MainPage: allValues.MainPage,
        Categories: catval,
        Tags: tagval,
        // Tags: "1",
        NewsBox: allValues.NewsBox,
        IsLast: allValues.IsLast,
        IsProminent: allValues.IsProminent,
        IsMostViewed: allValues.IsMostViewd,
        DatePublished: role == "Admin" ? allValues.DatePublished + "T" + allValues.TimePublished : null
        // DateModified:"2021-09-01T00:00:00",
      });
      console.log(dataUser)
      if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {

        //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
        alert("موفقیت آمیز");
        if (!accept) { navigate("/mainAdmin/PublishedNewses"); }

      }
      else {
        console.log(allValuesError)
        console.log(allValues)
        console.log(dataUser)
        setSnipper(false)

        setShowErrorModalStep1(true)
        setError(dataUser?.data ? dataUser?.data : "عملیات ناموفق بود");
      }
    }
    else {
      console.log(222)
      console.log(allValuesError)
      console.log(allValues)

      // setShowErrorModalStep1(true);
      setShowErrorModalStep1(true);
      setError("لطفا موارد ستاره دار را وارد نمایید")
      setSnipper(false)

    }
  }
  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength)
    }
  }
  useEffect(() => {
    const cookies = new Cookies();
    setRole(cookies.get('role'));
    setToken(cookies.get('token'));

    var catDef = []
    data?.articleCategories?.map((item) =>
      catDef.push({ value: item.categoryId, label: item.category.categoryName })
    )
    setSelectedOptions(catDef)

    var tagDef = []
    data?.articleTagTbls?.map((item) =>
      tagDef.push({ value: item.tagId, label: item.tag?.tag })
    )
    setTag(tagDef)
  }, []);

  const addTag = async (name) => {
    const normalizedName = name.trim();
    const existing = tags?.find((item) => item.label?.toLocaleLowerCase("fa") === normalizedName.toLocaleLowerCase("fa"));
    if (existing) {
      setTag((current) => current.some((item) => item.value === existing.value) ? current : [...current, existing]);
      return;
    }
    const dataUser = await axiosReq("Article/CreateTag", "post", {
      Tag: normalizedName,

    });
    console.log(dataUser)
    if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
      setRecheck(!reCheck)
      const options = await axiosReq("Article/GetEditorOptions", "get");
      const created = options?.tags?.find((item) => item.label?.toLocaleLowerCase("fa") === normalizedName.toLocaleLowerCase("fa"));
      if (created) setTag((current) => [...current, created]);
    }
    else {
      console.log(allValuesError)
      console.log(dataUser)

    }


  }
  return (
    <div className="rounded-[15px] pt-[15px] px-[15px] pb-[35px] border-borderGray border-2">
      <div className="mb-[22px]">
        <div className="mb-[12px]">
          <div>
            <div className="flex">
              <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-1">عنوان خبر</p>
              <p className="text-[#ff0000]">*</p>
            </div>
            <textarea
              name="ArticleTitle"
              onChange={changeHandler}
              onBlur={blurHandler}
              value={allValues?.ArticleTitle}
              // onInput={maxLengthCheck}
              // maxLength={100}
              className="h-[93px] w-full focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal p-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder="عنوان خبر را بنویسید" />
          </div>
          {
            allValuesError.ArticleTitle ?
              <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs mt-1 ml-1">
                لطفا فیلد را وارد نمایید !
              </span>
              :
              null
          }
        </div>
        <div className="mb-[12px]">
          <div>
            <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-1">عنوان دوم خبر (سو تیتر)</p>
            <textarea
              name="SecondTitle"
              onChange={changeHandler}
              onBlur={blurHandler}
              value={allValues?.SecondTitle}
              // onInput={maxLengthCheck}
              // maxLength={100}
              className="h-[93px] w-full focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal p-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder="عنوان خبر را بنویسید" />

          </div>
        </div>
        <div className="mb-[21px]">
          <div className="flex">

            <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-1">نامک</p>
            <p className="text-[#ff0000]">*</p>
          </div>
          <input
            name="Slug"
            onChange={changeHandler}
            // onChange={(e)=>console.log(e.target.value)}
            // onBlur={blurHandler}
            value={allValues?.Slug}
            // onInput={maxLengthCheck}
            className="h-[35px]  w-full focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" />
          {
            allValuesError.Slug ?
              <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs mt-1 ml-1">
                لطفا فیلد را وارد نمایید !
              </span>
              :
              null
          }
        </div>
        <div className="mb-[21px]">
          <div className="flex">

            <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-1">انتخاب دسته بندی</p>
            <p className="text-[#ff0000]">*</p>
          </div>
          <div className="w-full">
            <Select
              options={cats}
              isMulti
              value={selectedOptions}
              onChange={handleSelectChange}
              placeholder="دسته ‌ها را انتخاب کنید"
              styles={customStyles}
              className="text-[12px] font-IRANYekanNormal focus:outline-lightGray border-[1px] border-borderGray rounded-[5px]"
            />
            {
              errCat && selectedOptions.length == 0 ?
                <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs mt-1 ml-1">
                  لطفا فیلد را وارد نمایید !
                </span>
                :
                null
            }
          </div>
        </div>
        <div className="mb-[21px]">
          <div className="flex">

            <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-1">انتخاب برچسب ها </p>
            <p className="text-[#ff0000]">*</p>
          </div>
          <div className="w-full">
            <CreatableSelect
              options={tags}

              isMulti
              value={tag}
              onChange={handleTagChange}
              onCreateOption={(e) => addTag(e)}
              isClearable
              isSearchable
              filterOption={(option, input) => option.label.toLocaleLowerCase("fa").includes(input.toLocaleLowerCase("fa"))}
              placeholder="برچسب ها را انتخاب کنید"
              styles={customStyles}
              className="text-[12px] font-IRANYekanNormal focus:outline-lightGray border-[1px] border-borderGray rounded-[5px]"
            />
            {
              errTag && tag.length == 0 ?
                <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs mt-1 ml-1">
                  لطفا فیلد را وارد نمایید !
                </span>
                :
                null
            }
          </div>
        </div>

        {
          role == "Admin" ?
            <>
              <div className="mb-[21px]">
                <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-1">انتخاب تاریخ انتشار </p>
                <div className="w-full flex justify-start items-center px-3 h-[37px] text-[12px] font-IRANYekanNormal focus:outline-lightGray border-[2px] border-borderGray rounded-[5px]">
                  <DatePicker placeholder="تاریخ"
                    name="publicationDate"
                    // defaultValue={allValues.DatePublished?allValues.DatePublished:null}


                    onChange={(e) => { setAllValuesError({ ...allValuesError, DatePublished: false }); setAllValues({ ...allValues, DatePublished: formatDateTime(e.value) }) }}
                  />
                </div>

              </div>
              <div className="mb-[21px]">
                <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-1">انتخاب زمان انتشار </p>
                <div className="w-full flex justify-start items-center px-3 h-[37px] text-[12px] font-IRANYekanNormal focus:outline-lightGray border-[2px] border-borderGray rounded-[5px]">
                  <TimePicker placeholder="زمان"
                    name="publicationTime"
                    // defaultValue={allValues.TimePublished}
                    onChange={(e) => { setAllValuesError({ ...allValuesError, TimePublished: false }); setAllValues({ ...allValues, TimePublished: e.hour > 9 ? e.hour + ":" + e.minute : "0" + e.hour.toString() + ":" + e.minute }) }}
                  // onChange={(e) => console.log(e)}


                  />
                </div>

              </div>

              <div className="mb-[25px] flex flex-col">

                <div className="flex items-center mb-[15px]">
                  <input onChange={(e) => setAllValues({ ...allValues, MainPage: e.target.checked })} checked={allValues.MainPage} className="w-[15px] h-[15px]  accent-mainColor2 " type="checkbox" />
                  <label className="text-[12px] font-IRANYekanMedium text-mainColor2 mr-[5px]">نمایش خبر در بالای صفحه اصلی (3 خبر)</label>
                </div>
                <div className="flex items-center mb-[15px]">
                  <input onChange={(e) => setAllValues({ ...allValues, IsProminent: e.target.checked })} checked={allValues.IsProminent} className="w-[15px] h-[15px]  accent-mainColor2" type="checkbox" />
                  <label className="text-[12px] font-IRANYekanMedium text-mainColor2 mr-[5px]">نمایش خبر به عنوان خبر شاخص دسته بندی</label>
                </div>
                <div className="flex items-center mb-[15px]">
                  <input className="w-[15px] h-[15px]  accent-mainColor2" onChange={(e) => setAllValues({ ...allValues, IsLast: e.target.checked })} checked={allValues.IsLast} type="checkbox" />
                  <label className="text-[12px] font-IRANYekanMedium text-mainColor2 mr-[5px]">نمایش خبر به عنوان مهم ترین خبر (9 خبر)</label>
                </div>
                <div className="flex items-center">
                  <input className="w-[15px] h-[15px]  accent-mainColor2" onChange={(e) => setAllValues({ ...allValues, IsMostViewd: e.target.checked })} checked={allValues.IsMostViewd} type="checkbox" />
                  <label className="text-[12px] font-IRANYekanMedium text-mainColor2 mr-[5px]">نمایش خبر به عنوان خبر پر بازدید (10 خبر)</label>
                </div>
              </div>
            </>
            :
            null

        }




        <div className="mb-[20px]">
          <div>
            <div className="flex">

              <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-1">متن باکس</p>
              <p className="text-[#ff0000]">*</p>
            </div>
            <textarea
              name="NewsBox"
              onChange={changeHandler}
              onBlur={blurHandler}
              value={allValues?.NewsBox}
              // onInput={maxLengthCheck}
              // maxLength={100}
              className="h-[123px] w-full focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal p-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder="عنوان خبر را بنویسید" />
            {
              allValuesError.NewsBox ?
                <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs mt-1 ml-1">
                  لطفا فیلد را وارد نمایید !
                </span>
                :
                null
            }
          </div>
        </div>
        <div >
          <div>
            <div className="flex justify-between items-center mb-[5px]">
              <div className="flex">

                <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-1">انتخاب عکس شاخص</p>
                <p className="text-[#ff0000]">*</p>
              </div>
              <button className="w-[22px] h-[22px] bg-buttonRed rounded-full flex justify-center items-center" onClick={handleDeleteImage}><Delete /></button>
            </div>

            <div className="flex items-center justify-center w-full">
              <label
                htmlFor="dropzone-file"
                className="flex flex-col items-center justify-center w-full h-[168px] border-[1px] border-lightGray border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
              >
                {previewImage ? (
                  <img
                    src={previewImage}
                    alt="پیش‌نمایش"
                    className="w-full h-full object-cover rounded-lg"
                  />
                ) : (
                  <div className="flex flex-col items-center justify-center pt-5 pb-6">
                    {
                      token ?
                        <ArticleImageUpload setTitle={setTitle} setOpen={setOpen} setPhoto={setPhoto} token={token} prev={data ? apiAsset + data?.mainPicture : ""} />
                        :
                        null
                    }
                    <p className="text-[12px] font-IRANYekanMedium text-lightGray mt-2">
                      فایل را بارگزاری کنید
                    </p>
                  </div>
                )}

              </label>
            </div>
            {
              errPhoto && !data?.mainPicture ?
                <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs mt-1 ml-1">
                  لطفا فیلد را وارد نمایید !
                </span>
                :
                null
            }
          </div>
        </div>

      </div>
      <div className="flex justify-center items-center">
{
  sniper?
  <button disabled className="w-[152px] h-[42px] bg-infinity-gradient shadow-norm-shadow rounded-[5px] mt-2 flex justify-center items-center opacity-70">

  <div className="flex justify-center items-center">
  <ClipLoader
      color={"#000000"}
      loading={sniper}
      // cssOverride={override}
      size={30}
      aria-label="Loading Spinner"
      data-testid="loader"
  />
</div>
</button>
  :

        <button type="button" onClick={() => data ? updateArticle() : createArticle()} className="w-[152px] h-[42px] bg-infinity-gradient shadow-norm-shadow rounded-[5px] mt-2 flex justify-center items-center ">
          {
            accept || data ?

              <p className="font-IRANYekanBold text-[18px] text-white">ویرایش</p>
              :
              <p className="font-IRANYekanBold text-[18px] text-white">انتشار</p>

          }

        </button>
}


      </div>
      {showErrorModalStep1 ?
        <>
          <div
            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
          >
            <div className="relative w-[50%] lg:w-[50%] sm:w-[95%] my-5 mx-auto max-w-3xl">

              <div className="border-0 rounded-lg p-2 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">

                <div className="flex items-start justify-between p-4 border-b border-solid border-b-midGray rounded-t">
                  <span className="text-base font-bold   text-red">
                    عملیات ناموفق!
                  </span>

                </div>

                <div className="relative px-4 py-1 flex-auto">
                  <p className="my-4 text-black text-sm   leading-relaxed">
                    {error}                                              </p>
                </div>

                <div className="flex  items-center  justify-end border-solid border-slate-200 rounded-b">
                  <button

                    className="text-white  mx-4 mb-2  rounded-md shadow-blueShadow  bg-red font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowErrorModalStep1(false)}
                  >
                    فهمیدم
                  </button>

                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>

        </>
        : null
      }
    </div>
  )
}

export default UploadNewsSideInput;
